import { Action } from '../actions/types'

const INITIAL_STATE = {
    loading: false,
    requestArray: [],
    lastVisible: {},
    lastPage: false,
    currentIndex: 0,
    error: {}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Action.REQUESTS_LOADING:
            return {
                ...state,
                loading: true,
                error: {}
            }
        case Action.REQUESTS_INITIAL:
            return {
                ...state,
                loading: false,
                requestArray: action.payload.list,
                lastVisible: action.payload.lastVisible,
                lastPage: action.payload.lastPage

            }
        case Action.REQUESTS_MORE:
            return {
                ...state,
                loading: false,
                requestArray: [...state.requestArray, ...action.payload.list],
                lastVisible: action.payload.lastVisible,
                lastPage: action.payload.lastPage
            }
        case Action.REQUESTS_CURRENT_REQUEST:
            return {
                ...state,
                currentIndex: action.payload
            }
        case Action.REQUESTS_INITIALIZE_DIAGNOSIS:
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                diagnosis: {
                                    general: '',
                                    recommendations: '',
                                    images: [],
                                    sent: false 
                                }  // update image upload progress
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        case Action.REQUEST_DIAGNOSIS_SENT:
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                diagnosis: {
                                    ...request.data.diagnosis,
                                    sent: true
                                }
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        case Action.REQUESTS_SET_DIAGNOSIS:
            // console.log("initialize diagnosis")
            // console.log("reducer current index: ", state.currentIndex)
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                diagnosis: {
                                    ...request.data.diagnosis,
                                    [action.payload.name]: action.payload.event
                                }
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        case Action.REQUESTS_UPDATE_DIAGNOSIS_IMAGES:
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                diagnosis: {
                                    ...request.data.diagnosis,
                                    images: request.data.diagnosis.images
                                        ?   //If images exists, we add the iamge to the array
                                        [...request.data.diagnosis.images, action.payload]
                                        :   //If it doesn't exists, we create an array with the image
                                        [action.payload]
                                }
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        case Action.REQUESTS_RESET_CURRENT_IMAGES:
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                diagnosis: {
                                    ...request.data.diagnosis,
                                    images: []
                                }  // update image upload progress
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        case Action.REQUESTS_UPDATE_PAYMENT:
            return {
                ...state,
                requestArray: state.requestArray.map((request, index) => {
                    // Find the item with the matching id
                    if (index === state.currentIndex) {
                        // Return a new object
                        //console.log("encontramos el request")
                        return {
                            ...request,  // copy the existing item
                            data: {
                                ...request.data,
                                payment: {
                                    ...request.data.payment,
                                    data: {
                                        ...request.data.payment.data,
                                        paymentIntent: action.payload
                                    }
                                    
                                }
                            }
                        }
                    }

                    // Leave every other item unchanged
                    return request
                }),
            }
        default:
            return state
    }
}